export default {
	data() {
		return {
			scrollEnd: false,
			marginBottom: 10,
			scrollElement: window,
			scrollElementName: null,
			scrollHandler: () => {}
		};
	},
	mounted() {
		this.$nextTick(() => {
			if (this.scrollElementName) {
				this.scrollElement = this.$refs[this.scrollElementName];
			}
			this.scrollElement.addEventListener('wheel', this.onScrollHandler);
			this.scrollElement.addEventListener('scroll', this.onScrollHandler);
		});
	},
	beforeDestroy() {
		this.scrollElement.removeEventListener('wheel', this.onScrollHandler);
		this.scrollElement.removeEventListener('scroll', this.onScrollHandler);
	},
	methods: {
		onScrollHandler(e) {
			const container = this.scrollElement;
			if (this.scrollElementName) {
				this.scrollEnd =
					container.scrollTop >=
					container.scrollHeight -
						container.offsetHeight -
						this.marginBottom;

				if (this.scrollEnd) {
					this.$emit('scrollBoundary', e);
					this.scrollHandler(e);
				}
			} else {
				container.onscroll = () => {
					this.scrollEnd =
						window.innerHeight + window.scrollY >=
						document.body.offsetHeight;
						
					if (this.scrollEnd) {
						this.$emit('scrollBoundary', e);
						this.scrollHandler(e);
					}
				};
			}
		}
	}
};
